import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";
import { ConfirmationService } from "@jaspero/ng2-confirmations";
import { ResolveEmit } from "@jaspero/ng2-confirmations/src/interfaces/resolve-emit";
import { ModalDirective } from "ngx-bootstrap";

import { GUID, Param } from "app/brightserve/brightserve.module";

import { AddonService } from "app/add-ons/addon.service";
import { MedicalHistory, SlimScrollOptions } from "app/shared/shared.module";

@Component({
    selector: 'app-addon-medical-history',
    templateUrl: './addon-medical-history.component.html',
    styleUrls: ['./addon-medical-history.component.css']
})
export class AddonMedicalHistoryComponent implements OnInit {

    MedicalHistory: MedicalHistory[];
    MedicalHistoryNote: string;
    GetMedicalHistorySubscription: Subscription;
    CreateMedicalHistorySubscription: Subscription;

    SlimScrollOptions = SlimScrollOptions;

    @Input() PatientId: GUID;
    @Input() EnableAdd: boolean = false;
    @Input() EnableDelete: boolean = false;

    CanEnableAdd: boolean = false;
    CanEnableDelete: boolean = false;

    @ViewChild('MedicalHistoryModal') public modal: ModalDirective

    constructor(private addonService: AddonService, private _confirmation: ConfirmationService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.CanEnableAdd = this.EnableAdd;
        this.CanEnableDelete = this.EnableDelete;
    }

    ngOnChanges() {
        if (this.PatientId) {
            this.GetMedicalHistory();
            this.EnableAdd = this.CanEnableAdd;
            this.EnableDelete = this.CanEnableDelete;
        }
        else {
            this.EnableAdd = false;
            this.EnableDelete = false;
        }
    }

    ngOnDestroy() {
        if (this.GetMedicalHistorySubscription != null)
            this.GetMedicalHistorySubscription.unsubscribe();
        if (this.CreateMedicalHistorySubscription != null)
            this.CreateMedicalHistorySubscription.unsubscribe();
    }

    OpenModal() {
        this.modal.show();
    };

    GetMedicalHistory() {
        if (this.PatientId) {
            this.GetMedicalHistorySubscription = this.addonService.GetMedicalHistoryForPatient(this.PatientId).subscribe(
                medicalHistory => {
                    this.MedicalHistory = medicalHistory;
                }, err => {
                    this._notification.error("Data Error", "Medical History data for this patient could not be obtained.");
                }
            );
        }
    };

    SaveMedicalHistory() {
        var medicalHistory = MedicalHistory.BlankMedicalHistory({ Created: new Date(), Text: this.MedicalHistoryNote});
        medicalHistory.Status = new Param({ Entity: "Annotation", Field: "Status", Value: "New" });

        this.CreateMedicalHistorySubscription = this.addonService.AddMedicalHistoryToPatient(this.PatientId, medicalHistory).subscribe(
            data => {
                this._notification.success("Save Success", "Your medical history was saved successfully.");
                this.modal.hide();
                this.GetMedicalHistory();

            }, err => {
                this._notification.error("Data Error", "Medical History data for this patient could not be obtained.");
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/app/add-ons/medical-history/addon-medical-history.component.ts